module.exports = __webpack_public_path__ + "assets/emoji.7cb09dce.svg";